var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilesIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.333 1.513v2.753c0 .374 0 .56.073.703a.667.667 0 00.291.291c.143.073.33.073.703.073h2.754m-3.82 6h-4m5.333-2.667H5.333m8-2.008v4.808c0 1.12 0 1.68-.218 2.108a2 2 0 01-.874.874c-.427.218-.987.218-2.108.218H5.867c-1.12 0-1.68 0-2.108-.218a2 2 0 01-.874-.874c-.218-.428-.218-.988-.218-2.108V4.533c0-1.12 0-1.68.218-2.108a2 2 0 01.874-.874c.428-.218.988-.218 2.108-.218h2.14c.49 0 .735 0 .965.055a2 2 0 01.578.24c.202.123.375.296.72.642l2.126 2.126c.346.346.519.519.643.72.11.18.19.374.24.579.054.23.054.474.054.963z",
    stroke: "#fff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgFilesIcon;